<header class="header">
<div class="container">
    <div class="row align-items-center">
    <div class="col-md-6">
        <div class="logo">
        <a href="/">
            <img src="assets/images/logo.png" alt="pdf to word" class="logo-img">
        </a>
        </div>
    </div>
    <div class="col-md-6">
        <nav class="nav-menu">
        <span class="user-greeting" *ngIf="email">Bonjour {{ email }}</span>
        <a href="#" class="nav-link btn-primary" (click)="onLogout()">DECONNEXION</a>
        </nav>
    </div>
    </div>
</div>
</header>
  